import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { FlowConfig } from '../../../config/FlowTypes';
import { imagesFromFlowConfig } from './ImagesFromFlowConfig';

type Props = {
  flowConfig: FlowConfig<string>;
};

/**
 * Extract image paths from flow config and preload them by placing them in the
 * html <head /> as preload links. This tells the browser to load the image
 * without need to add an <img /> tag.
 */
export const PreloadFlowImages: FunctionComponent<Props> = (props) => {
  const imagesToPreload = imagesFromFlowConfig(props.flowConfig);
  return (
    <Helmet>
      {imagesToPreload.map((imagePath) => (
        <link key={imagePath} rel="preload" as="image" href={imagePath} />
      ))}
    </Helmet>
  );
};
